<template>
  <div class="latest-activity latest-block">
    <div class="latest-activity-inner" v-if="latest">
      <div class="latest-activity-text">
        <span>{{ text }}</span>
      </div>
      <h2>{{ latest.title }}</h2>
      <a class="md-button after-title latest-activity-continue" :href="'node/' + latest.id"
      >{{ button }}</a>
      <div v-if="latest.competencies.length" class="md-small-hide latest-activity-competencies"
      >Competency: {{ latest.competencies ? latest.competencies.join(", ") : "" }}
      </div>
      <div class="md-small-hide latest-activity-description" v-html="latest.description"></div>
      <img v-if="latest.icon" :src="latest.icon" alt/>
      <a class="md-button latest-activity-continue" :href="'node/' + latest.id">{{ button }}</a>
    </div>
    <div class="latest-activity-inner empty" v-else>
      <div class="latest-activity-text">
        <span v-show="$mq == 'large' || $mq == 'xlarge'">continue with</span>
      </div>
      <h2>You are up to date</h2>
      <a class="md-button after-title latest-activity-continue" href="/teacher-dashboard">Continue to dashboard</a>

      <div v-show="$mq == 'large' || $mq == 'xlarge'" class="latest-activity-description">
        You currently don't have any activities or assignments. Continue to <br/>
        your dashboard to review any past work.
      </div>
      <img class="all-done-img" src="../assets/lc-up-to-date.svg"/>
      <a class="md-button latest-activity-continue" href="/teacher-dashboard">Dashboard</a>

    </div>
  </div>
</template>

<script>
export default {
  name: "LatestActivity",
  data() {
    return {
      latest: null,
      button: 'Start',
      text: 'Try next',
    };
  },
  mounted() {
    if (window.drupalSettings.controller) {
      this.latest = window.drupalSettings.controller
        ? window.drupalSettings.controller.latest
        : null;
      this.button = window.drupalSettings.controller.latest
        ? window.drupalSettings.controller.latest.button
        : 'Start';
      this.text = window.drupalSettings.controller.latest
        ? window.drupalSettings.controller.latest.text
        : 'Try next';
    }
  }
};
</script>
<style lang="scss">
.all-done-img {
  @media all and (min-width: $breakpoint-medium) {
    width: 330px !important;
  }
}
</style>
